import i18n from '~/utils/i18n';
import moment from 'moment-timezone';
import { GOAL_TYPES, CAMPAIGN_TYPES } from '~/utils/constants';
import imageData from './image-default.png';
import fbImageData from './fb-page-default.png';

export const image = imageData;
export const fbImage = fbImageData;

// TODO: the texts should be ok for both placeholder and preview
export const creative = (config) => ({
  type: CAMPAIGN_TYPES.IMAGE,
  message: i18n.t('pos.campaign.creatives.adv-builder.defaults.creative.message'),
  name: i18n.t(`pos.campaign.creatives.adv-builder.defaults.creative.${config.isOffer ? 'offer_title' : 'name'}`),
  description: i18n.t('pos.campaign.creatives.adv-builder.defaults.creative.description'),
  caption: i18n.t('pos.campaign.creatives.adv-builder.defaults.creative.caption'),
  cta: config.isOffer ? GOAL_TYPES.GET_OFFER : GOAL_TYPES.LEARN_MORE,
  transition_ms: 500,
  duration_ms: 1750,
});

// TODO: the texts should be ok for both placeholder and preview
export const media = (config) => ({
  isVideo: false,
  link: '#',
  name: i18n.t(`pos.campaign.creatives.adv-builder.defaults.card.${config.isOffer ? 'offer-' : ''}name`),
  description: i18n.t('pos.campaign.creatives.adv-builder.defaults.card.description'),
  path: imageData,
  thumbnail: imageData,
});

export const offerConfig = () => ({
  title: i18n.t('pos.campaign.creatives.adv-builder.defaults.creative.offer_title'),
  details: i18n.t('pos.campaign.creatives.adv-builder.defaults.creative.offer_details'),
  end_date_time: null,
  date_range_start: moment().set('hour', 0).set('minute', 0).add(4, 'day')
    .toISOString(),
  date_range_end: moment().add(1, 'year').toISOString(),
  type: null,
  code_type: 'none',
  redeem: 'store',
  offer_url: null,
  code: i18n.t('pos.campaign.creatives.adv-builder.defaults.creative.offer_code'),
  t_c: i18n.t('pos.campaign.creatives.adv-builder.defaults.creative.t_c'),
});

export const facebookPage = () => ({ // eslint-disable-line
  link: '#',
  name: 'TODO',
  picture: fbImageData,
});

export const landingPage = () => ({
  link: i18n.t('pos.campaign.creatives.adv-builder.defaults.creative.see_more_at_url'),
  see_more: i18n.t('pos.campaign.creatives.adv-builder.defaults.creative.see_more_at'),
});

export const basicCreativeKeys = [
  'type',
  'message', 'name', 'description', 'caption', 'cta',
  'transition_ms', 'duration_ms',
];

export const basicMediaKeys = ['isVideo', 'link', 'name', 'description'];

export const basicOfferConfigKeys = [
  'code', 'code_type', 'date_range_end', 'date_range_start', 'details',
  'end_date_time', 'offer_details', 'offer_url', 'redeem', 't_c', 'title', 'type',
];

export const basicFbPageKeys = ['link', 'name', 'picture'];

export const basicLandingPageKeys = ['link', 'see_more'];



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/creative-preview/defaults.js